/* NHD - Heart Palpitations : MASTERCLASS REPLAY (on-demand).
   Loaded only by the Custom Liquid block on templates/page.palp-masterclass-replay.json.
   Every query is scoped to .nhd-palprep so nothing in the theme is touched.
   Flavia's page behaviour plus the YouTube facade and segment lightbox from
   nhd-hapev.js. No library, no globals. */
(function () {
  var root = document.querySelector('.nhd-palprep');
  if (!root) return;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var YT = 'https://www.youtube-nocookie.com/embed/';
  var PARAMS = '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

  function looksLikeId(v) {
    return !!v && /^[A-Za-z0-9_-]{11}$/.test(v);
  }

  function frame(id, title) {
    var f = document.createElement('iframe');
    f.src = YT + encodeURIComponent(id) + PARAMS;
    f.title = title || 'Natural Heart Doctor video';
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return f;
  }

  /* ---- 1. Inline click-to-load facade (hero masterclass) ---- */
  Array.prototype.forEach.call(root.querySelectorAll('.ytf'), function (el) {
    var id = el.getAttribute('data-yt');
    if (!looksLikeId(id)) {
      /* Placeholder id still in place. Leave the poster up rather than loading
         a broken player, and do not trap the keyboard on it. */
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
      el.style.cursor = 'default';
      return;
    }
    function activate() {
      if (el.classList.contains('ytf-loaded')) return;
      el.classList.add('ytf-loaded');
      el.innerHTML = '';
      el.appendChild(frame(id, el.getAttribute('aria-label')));
    }
    el.addEventListener('click', activate);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); activate(); }
    });
  });

  /* ---- 2. Segment lightbox ---- */
  var box = root.querySelector('#nhdPalprepLightbox');
  var frameHost = box ? box.querySelector('.ytlb-frame') : null;
  var capHost = box ? box.querySelector('.ytlb-cap') : null;
  var closeBtn = box ? box.querySelector('.ytlb-close') : null;
  var lastFocus = null;

  function closeBox() {
    if (!box || box.hidden) return;
    box.hidden = true;
    frameHost.innerHTML = '';
    capHost.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openBox(id, title, trigger) {
    if (!box || !looksLikeId(id)) return;
    lastFocus = trigger || null;
    frameHost.innerHTML = '';
    frameHost.appendChild(frame(id, title));
    capHost.innerHTML = title || '';
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-yt-lightbox]'), function (btn) {
    var id = btn.getAttribute('data-yt-lightbox');
    if (!looksLikeId(id)) {
      /* Placeholder id. Disable rather than open an empty player. */
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '.45';
      btn.style.cursor = 'not-allowed';
      return;
    }
    btn.addEventListener('click', function () {
      openBox(id, btn.getAttribute('data-yt-title'), btn);
    });
  });

  if (box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-ytlb-close]'), function (el) {
      el.addEventListener('click', closeBox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeBox();
    });
    /* Keep tab focus inside the dialog while it is open. */
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || box.hidden) return;
      e.preventDefault();
      if (closeBtn) closeBtn.focus();
    });
  }

  /* ---- 3. Scroll reveal ---- */
  var els = root.querySelectorAll('.sec-head, .pcard, .res-card, .faq-item, .hero-offer, .tl-node, .pull');
  Array.prototype.forEach.call(els, function (el, i) {
    el.classList.add('rv');
    el.style.transitionDelay = (i % 3) * 70 + 'ms';
  });
  if (!('IntersectionObserver' in window) || reduce) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
  } else {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in'); ro.unobserve(e.target);
          /* drop the stagger delay once revealed, so hover responds instantly */
          setTimeout(function () { e.target.style.transitionDelay = '0ms'; }, 700);
        }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) { ro.observe(el); });
  }

  /* ---- 4. ECG line draws once ---- */
  var band = root.querySelector('.ecg-band');
  if (band) {
    if (!('IntersectionObserver' in window) || reduce) { band.classList.add('play'); }
    else {
      var eo = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { band.classList.add('play'); eo.disconnect(); } });
      }, { threshold: 0.35 });
      eo.observe(band);
    }
  }

  /* ---- 5. Review timeline rail draws, then each node lands ---- */
  Array.prototype.forEach.call(root.querySelectorAll('.tl'), function (tl) {
    if (!('IntersectionObserver' in window) || reduce) { tl.classList.add('play'); return; }
    var to = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { tl.classList.add('play'); to.disconnect(); } });
    }, { threshold: 0.3 });
    to.observe(tl);
  });

  /* ---- 6. Smooth scroll for in-page anchors, offset for the sticky nav.
             Links whose target is not on the page are left alone, so the two
             unwired resource placeholders do nothing instead of jumping. ---- */
  var nav = root.querySelector('.nhd-nav');
  Array.prototype.forEach.call(root.querySelectorAll('a[href^="#"]'), function (a) {
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
    if (!target) {
      /* Unwired placeholder. Swallow the click so the page does not jump. */
      a.addEventListener('click', function (e) { e.preventDefault(); });
      return;
    }
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var offset = (nav && getComputedStyle(nav).position === 'sticky') ? nav.offsetHeight + 12 : 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---- 7. Free webinar replay click.
             The link goes to YouTube, which discards UTMs and reports nothing
             back, so the click is measured here instead. This only pushes to
             the dataLayer. A GTM tag still has to be built to consume it. ---- */
  var replay = root.querySelector('[data-nhd-replay-click]');
  if (replay) {
    replay.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_replay_click',
        page: 'palpitations-masterclass',
        placement: 'resources-webinar-replay'
      });
    });
  }

  /* ---- 8. Sticky mobile CTA hides once the offer section is on screen.
             Flavia's script watched .steps, a section this page does not have,
             so the CTA never hid. It watches the offer instead. ---- */
  var sticky = root.querySelector('.sticky-cta');
  var offer = root.querySelector('#nhd-palprep-next-step');
  if (sticky && offer && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.style.visibility = e.isIntersecting ? 'hidden' : 'visible'; });
    }, { threshold: 0.15 });
    so.observe(offer);
  }
})();
/* NHD - Heart Palpitations : MASTERCLASS REPLAY (on-demand).
   Loaded only by the Custom Liquid block on templates/page.palp-masterclass-replay.json.
   Every query is scoped to .nhd-palprep so nothing in the theme is touched.
   Flavia's page behaviour plus the YouTube facade and segment lightbox from
   nhd-hapev.js. No library, no globals. */
(function () {
  var root = document.querySelector('.nhd-palprep');
  if (!root) return;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var YT = 'https://www.youtube-nocookie.com/embed/';
  var PARAMS = '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

  function looksLikeId(v) {
    return !!v && /^[A-Za-z0-9_-]{11}$/.test(v);
  }

  function frame(id, title) {
    var f = document.createElement('iframe');
    f.src = YT + encodeURIComponent(id) + PARAMS;
    f.title = title || 'Natural Heart Doctor video';
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return f;
  }

  /* ---- 1. Inline click-to-load facade (hero masterclass) ---- */
  Array.prototype.forEach.call(root.querySelectorAll('.ytf'), function (el) {
    var id = el.getAttribute('data-yt');
    if (!looksLikeId(id)) {
      /* Placeholder id still in place. Leave the poster up rather than loading
         a broken player, and do not trap the keyboard on it. */
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
      el.style.cursor = 'default';
      return;
    }
    function activate() {
      if (el.classList.contains('ytf-loaded')) return;
      el.classList.add('ytf-loaded');
      el.innerHTML = '';
      el.appendChild(frame(id, el.getAttribute('aria-label')));
    }
    el.addEventListener('click', activate);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); activate(); }
    });
  });

  /* ---- 2. Segment lightbox ---- */
  var box = root.querySelector('#nhdPalprepLightbox');
  var frameHost = box ? box.querySelector('.ytlb-frame') : null;
  var capHost = box ? box.querySelector('.ytlb-cap') : null;
  var closeBtn = box ? box.querySelector('.ytlb-close') : null;
  var lastFocus = null;

  function closeBox() {
    if (!box || box.hidden) return;
    box.hidden = true;
    frameHost.innerHTML = '';
    capHost.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openBox(id, title, trigger) {
    if (!box || !looksLikeId(id)) return;
    lastFocus = trigger || null;
    frameHost.innerHTML = '';
    frameHost.appendChild(frame(id, title));
    capHost.innerHTML = title || '';
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-yt-lightbox]'), function (btn) {
    var id = btn.getAttribute('data-yt-lightbox');
    if (!looksLikeId(id)) {
      /* Placeholder id. Disable rather than open an empty player. */
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '.45';
      btn.style.cursor = 'not-allowed';
      return;
    }
    btn.addEventListener('click', function () {
      openBox(id, btn.getAttribute('data-yt-title'), btn);
    });
  });

  if (box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-ytlb-close]'), function (el) {
      el.addEventListener('click', closeBox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeBox();
    });
    /* Keep tab focus inside the dialog while it is open. */
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || box.hidden) return;
      e.preventDefault();
      if (closeBtn) closeBtn.focus();
    });
  }

  /* ---- 3. Scroll reveal ---- */
  var els = root.querySelectorAll('.sec-head, .pcard, .res-card, .faq-item, .hero-offer, .tl-node, .pull');
  Array.prototype.forEach.call(els, function (el, i) {
    el.classList.add('rv');
    el.style.transitionDelay = (i % 3) * 70 + 'ms';
  });
  if (!('IntersectionObserver' in window) || reduce) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
  } else {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in'); ro.unobserve(e.target);
          /* drop the stagger delay once revealed, so hover responds instantly */
          setTimeout(function () { e.target.style.transitionDelay = '0ms'; }, 700);
        }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) { ro.observe(el); });
  }

  /* ---- 4. ECG line draws once ---- */
  var band = root.querySelector('.ecg-band');
  if (band) {
    if (!('IntersectionObserver' in window) || reduce) { band.classList.add('play'); }
    else {
      var eo = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { band.classList.add('play'); eo.disconnect(); } });
      }, { threshold: 0.35 });
      eo.observe(band);
    }
  }

  /* ---- 5. Review timeline rail draws, then each node lands ---- */
  Array.prototype.forEach.call(root.querySelectorAll('.tl'), function (tl) {
    if (!('IntersectionObserver' in window) || reduce) { tl.classList.add('play'); return; }
    var to = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { tl.classList.add('play'); to.disconnect(); } });
    }, { threshold: 0.3 });
    to.observe(tl);
  });

  /* ---- 6. Smooth scroll for in-page anchors, offset for the sticky nav.
             Links whose target is not on the page are left alone, so the two
             unwired resource placeholders do nothing instead of jumping. ---- */
  var nav = root.querySelector('.nhd-nav');
  Array.prototype.forEach.call(root.querySelectorAll('a[href^="#"]'), function (a) {
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
    if (!target) {
      /* Unwired placeholder. Swallow the click so the page does not jump. */
      a.addEventListener('click', function (e) { e.preventDefault(); });
      return;
    }
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var offset = (nav && getComputedStyle(nav).position === 'sticky') ? nav.offsetHeight + 12 : 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---- 7. Free webinar replay click.
             The link goes to YouTube, which discards UTMs and reports nothing
             back, so the click is measured here instead. This only pushes to
             the dataLayer. A GTM tag still has to be built to consume it. ---- */
  var replay = root.querySelector('[data-nhd-replay-click]');
  if (replay) {
    replay.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_replay_click',
        page: 'palpitations-masterclass',
        placement: 'resources-webinar-replay'
      });
    });
  }

  /* ---- 8. Sticky mobile CTA hides once the offer section is on screen.
             Flavia's script watched .steps, a section this page does not have,
             so the CTA never hid. It watches the offer instead. ---- */
  var sticky = root.querySelector('.sticky-cta');
  var offer = root.querySelector('#nhd-palprep-next-step');
  if (sticky && offer && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.style.visibility = e.isIntersecting ? 'hidden' : 'visible'; });
    }, { threshold: 0.15 });
    so.observe(offer);
  }
})();
